module.exports = __webpack_public_path__ + "static/media/trial1_2.7727e3b4.png";